import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const MenuClassName = `${CLASS_NAME_PREFIX}-menu`;
export const SubMenuClassName = `${CLASS_NAME_PREFIX}-sub-menu`;
export const MenuSeparatorClassName = `${CLASS_NAME_PREFIX}-separator`;
export const MenuItemClassName = `${MenuClassName}__menu-item`;
export const MenuItemChildrenClassName = `${MenuItemClassName}-children`;
export const MenuItemStartIconClassName = `${MenuItemClassName}-start-icon`;
export const MenuItemEndIconClassName = `${MenuItemClassName}-end-icon`;

{
  /* sideOffset is a number in Radix. */
}
export const SIDE_OFFSET = 4;
